import Vue from 'vue'
import Vuex from 'vuex'
import { clearUserScaleDrafts } from '@/utils/scaleDraftCache'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        userId: localStorage.getItem('user_id') || '',
        user: null,
        profile: null,
    },
    getters: {
        isAuthenticated: (state) => Boolean(state.token && state.userId),
    },
    mutations: {
        setAuth(state, payload) {
            const token = payload.token || ''
            const userId = payload.userId || ''
            state.token = token
            state.userId = userId
            state.user = payload.user || null
            localStorage.setItem('token', token)
            localStorage.setItem('user_id', userId)
        },
        setProfile(state, profile) {
            state.profile = profile || null
        },
        clearAuth(state) {
            const userId = state.userId || localStorage.getItem('user_id') || ''
            clearUserScaleDrafts(userId)
            state.token = ''
            state.userId = ''
            state.user = null
            state.profile = null
            localStorage.removeItem('token')
            localStorage.removeItem('user_id')
        },
    },
    actions: {},
    modules: {},
})
